import { Moment } from 'moment';
import Filtros from './Filtros';
import TableProdutos, { InputProduto } from './TableProdutos';
import { Box } from '@mui/material';
import { ModalDetalheProdutoProvider } from '../../../screens/Estoque/components/MIProdutos/ModalDetalheProdutoContext';

export default function SelecionarProduto({
  isRessuprimento = false
}: SelecionarProdutoProps) {

  return (
    <Box sx={{ mt: isRessuprimento ? 4 : 0 }}>
      <Filtros isRessuprimento={isRessuprimento} />
      <ModalDetalheProdutoProvider>
        <TableProdutos isRessuprimento={isRessuprimento} />
      </ModalDetalheProdutoProvider>
    </Box>
  )
}

interface SelecionarProdutoProps {
  isRessuprimento?: boolean
}

export type InputsSelecionarProduto = {
  filtros: {
    origem: number | null
  },
  origem_loja_id: number | null;
  destino_loja_id: number | null;
  periodo_inicio: string | null;
  periodo_fim: string | null;
  sazonalidade_inicio: string | null;
  sazonalidade_fim: string | null;
  items: Array<InputProduto>;
  descricao: string;
  observacao: string | null;
  nao_sugeridos: Array<InputProduto>;
  filters: IFiltrosSelecionarProduto
}

export interface IFiltrosSelecionarProduto {
  limit: number;
  page: number;
  palavra_chave: string,
  periodo_vendas_inicio: Moment;
  periodo_vendas_fim: Moment;
  sazonalidade_inicio: Moment;
  sazonalidade_fim: Moment;
  sazonalidades_ids: number[] | null;
  qtdSuggestion: number;
  origem: any;
  destino: any;
  predSelecionado: FiltrosPreDefinidos | null
  departamentos?: Array<{
    id: number,
    nome: string
  }>,
  setores?: Array<{
    id: number,
    nome: string
  }>,
  niveis_estoque: Array<string>
  mostrar_itens_sem_estoque_origem: boolean,
  calcular_nivel_global: boolean,
}

export interface FiltrosPreDefinidos {
  nome: string,
  filtros: {
    origem: {
      id: number,
      nome: string
    },
    departamentos: Array<{
      id: number,
      nome: string
    }>
  }
}

